<template>
  <label class="ui-switch" :class="{ disabled }" :title="disabled ? disabledTitle : ''">
    <input
      v-model="localValue"
      type="checkbox"
      :disabled="disabled"
    >
    <div class="ui-switch-slider">
      <div class="ui-switch-knob"></div>
    </div>
  </label>
</template>

<script>
  export default {
    props: {
      value: Boolean,
      disabled: Boolean,
      disabledTitle: {
        type: String,
        default: 'Select a building to enable'
      }
    },
    data: () => ({ localValue: null }),
    watch: {
      value(to) { this.localValue = to; },
      localValue(to) { this.$emit('input', to); }
    },
    created() { this.localValue = this.value; }
  };
</script>

<style lang="scss">
.ui-switch {
  display: block;
  width: 45px;
  height: 25px;
  cursor: pointer;
  position: relative;
}

.ui-switch.disabled { cursor: not-allowed; opacity: .6; }


.ui-switch input[type="checkbox"] {
  display: none;
}

.ui-switch input[type="checkbox"]:checked+.ui-switch-slider {
  background-color: #44cc66;
}

.ui-switch-slider {
  background-color: #ccc;
  position: absolute;
  border-radius: 100px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-transition: all 300ms ease;
  transition: all 300ms ease;
}

.ui-switch-knob {
  position: absolute;
  -webkit-transition: all 300ms ease;
  transition: all 300ms ease;
}

.ui-switch input[type="checkbox"]:checked+.ui-switch-slider .ui-switch-knob {
  left: calc(100% - 19px - 3px);
}

.ui-switch-knob {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  left: 0;
  top: 0;
  background-color: #fff;
  //-webkit-box-shadow: 0 2px 6px rgba(153, 153, 153, 0.75);
  //box-shadow: 0 2px 6px rgba(153, 153, 153, 0.75);
}
</style>
